import Vue, { VueConstructor } from "vue";
import { throttle, debounce } from "throttle-debounce";

export interface IBrowserPlugin {
  readonly width: number;
  readonly height: number;
  readonly windowArea: number;
}

class BrowserPlugin implements IBrowserPlugin {
  _vo: {
    width: number;
    height: number;
  };

  constructor() {
    this._vo = Vue.observable({
      width: window.innerWidth,
      height: window.innerHeight
    });

    let resizeFunction = () => {
      this._vo.width = window.innerWidth;
      this._vo.height = window.innerHeight;
    };

    window.addEventListener("resize", event => {
      resizeFunction();

      setTimeout(() => {
        resizeFunction();
      }, 200);
    });
  }

  get width (){
    return this._vo.width;
  }

  get height (){
    return this._vo.height;
  }

  get windowArea (){
    return this._vo.width * this._vo.height;
  }
}


export default function (_vue: VueConstructor){
    _vue.prototype.$browser = new BrowserPlugin();
}

declare module 'vue/types/vue' {
  interface Vue {
      $browser: IBrowserPlugin;
  }
}